module.exports = __webpack_public_path__ + "img/contrato_flexfamilia.c6e80afa.jpg";